import { z } from "zod";
import { baseEntitySchema } from "./base";

export const noteTemplateDataSchema = z.object({
  productId: z.string().optional(),
  productName: z.string().optional(),
  content: z.string(),
});

export type NoteTemplateData = z.infer<typeof noteTemplateDataSchema>;
export const noteTemplateSchema = baseEntitySchema.merge(noteTemplateDataSchema);
export type NoteTemplate = z.infer<typeof noteTemplateSchema>;
